import axiosWrapper from './axiosWrapper'

const URL_ORDEN_COMPRA = `api/compras`

const buscar = (axiosParams, busqueda) => {
  const url = `${axiosParams.baseURL}/${URL_ORDEN_COMPRA}/buscar`
  return axiosWrapper.post({ ...axiosParams, url }, busqueda)
}

const getCompra = (axiosParams, id) => {
  const url = `${axiosParams.baseURL}/${URL_ORDEN_COMPRA}/${id}`
  return axiosWrapper.get({ ...axiosParams, url })
}

const addComentario = (axiosParams, id, comentario) => {
  const url = `${axiosParams.baseURL}/${URL_ORDEN_COMPRA}/${id}/addComentario`
  return axiosWrapper.post({ ...axiosParams, url }, comentario)
}

const uploadFile = (axiosParams, idCompra, data) => {
  const url = `${axiosParams.baseURL}/${URL_ORDEN_COMPRA}/${idCompra}/upload`
  return axiosWrapper.post({ ...axiosParams, url }, data)
}

const cambiarEstadoOC = (axiosParams, idCompra) => {
  const url = `${axiosParams.baseURL}/${URL_ORDEN_COMPRA}/${idCompra}/cambiarEstadoCompra`
  return axiosWrapper.post({ ...axiosParams, url })
}

const estadisticas = (axiosParams, busqueda) => {
  const url = `${axiosParams.baseURL}/${URL_ORDEN_COMPRA}/estadisticas`
  return axiosWrapper.post({ ...axiosParams, url }, busqueda)
}

const notificaciones = (axiosParams, busqueda) => {
  const url = `${axiosParams.baseURL}/${URL_ORDEN_COMPRA}/notififacionesSinResponder`
  return axiosWrapper.post({ ...axiosParams, url }, busqueda)
}

const serviceOrdenCompra = {
  buscar,
  getCompra,
  addComentario,
  uploadFile,
  cambiarEstadoOC,
  estadisticas,
  notificaciones
}

export default serviceOrdenCompra
